import { Model } from './Model';

export class FilterDownloader extends Model {
  public apiPath = undefined;
  public className = 'filterdownloader';
  public downloadUrl?: string;
  public blockedItemsCount?: number;
}
